<button
  type="button"
  class="d-flex justify-content-center align-items-center p-0 m-0"
  (click)="buttonClick.emit()"
  [disabled]="disabled">
  <img src="assets/image/plus.svg" class="d-block" alt="plus-icon">
</button>
